import {fetch_retry_post, downloadFile, fetch_retry_get, checkStatus } from "../redux/actions/ApiManager";
import { getEnv } from "../enviroment";
import { CONSTANTS } from "../common/constants/constants";
import axios from "axios";

const { base } = getEnv();
function headerRequest() {
  const authtoken = localStorage.getItem("authToken");
  let authType =
    localStorage.getItem("pingAccessToken") !== null
      ? "PING_AUTH"
      : "PASSCODE_AUTH";
  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    authType: `${authType}`,
    "x-authtoken": `${authtoken}`,
    Authorization: `${authtoken}`,
  };
}
const falconDownloadLogs = async(payload,databasename) =>  {
  try {
    let logFile =databasename.split(" ").join("_");
    let fileName = logFile + "_" + payload.startDate.replace(/-/g, "") + "_" + payload.endDate.replace(/-/g, "");
    const downloadResponse = await axios
      .post(`${base}/falcon/download`, JSON.stringify(payload), {
        headers: headerRequest(),
        responseType: "blob",
      })
      .then((response) => {
        const href = URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = href;
        link.setAttribute("download", fileName + ".csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });
      return { success: true, message:downloadResponse };
  } catch (error) {
    console.error(error);
    checkStatus(error.response);
    return error.response;
  }
};

const getDatabaseList = async (payload, client) => {
  try {
    let response = await fetch_retry_get(
      `${base}/falcon/databases`
    );
    let resp = await response;
    if (resp && (resp.status === 200 || resp.status === 201)) {
      return { success: true, data: resp.data };
    } else {
      return { success: false, message: resp.data.message };
    }
  } catch (error) {
    console.error("error", error);
    return { success: false, message: error.data };
  }
};

// view epms logs
const falconViewLogs = async(payload) =>  {
  try {
    let response = await fetch_retry_post(`${base}/falcon/view`,payload);
    if (response.status === 200 || response.status === 201) {
      return { success: true, data:response.data };
    } else {
      return { success: false, message:response.data.message };
    }
   
  } catch (error) {
    return { success: false, message:error.data };
  }
};
export const falconService = {
  falconDownloadLogs,
  falconViewLogs,
  getDatabaseList
};
  